import React from 'react';
import { connect } from 'react-redux';
import { Redirect } from 'react-router-dom';
import { withStyles } from '@material-ui/core/styles';
import MeetingRoomIcon from '@material-ui/icons/MeetingRoom';
import { Flag, Menu } from 'semantic-ui-react';

import CartService from 'shared/services/CartService';
import AdminDialog from 'app/components/AdminDialog';
import TimeOutDialog from 'app/components/TimeOutDialog';
import RoomDialog from 'app/components/RoomDialog';
import StripeReadersDialog from './StripeReadersDialog';
import config from 'shared/config/config';
import messages, { FormattedMessage, withValues } from 'shared/messages/messages';

import {
  logout,
  sendEmail,
  setEmail
} from 'app/actions/kioskActions';

import {
  selectLocale
} from 'shared/actions/messagesActions';

import {
  getLocaleSettings,
  getEnabledLocales
} from 'app/selectors/kioskSelectors';

import {
  KIOSK_LOGO_URL,
  CLUB_MED_LOGIN_TYPE
} from 'app/utils/Constants';

import {
  formatGuestName
} from 'app/utils/Utils';

import {
  trackEvent
} from 'shared/services/Analytics';

import {
  HPX_THEME,
  CLUBMED_THEME,
  ICECASTLE_THEME
} from 'shared/config/themes';

import UserService from 'shared/services/UserService';


const styles = () => ({
  wrapper: {
    position: 'fixed',
    zIndex: 99999,
    top: 0,
    left: 0,
    right: 0,
    height: '2.85rem',
    background: 'linear-gradient(#fafafa, #fff, #fafafa)',
    borderBottom: ' 1px solid #ddd',
    boxShadow: '0 0 2px rgba(0, 0, 0, 0.1)'
  },
  content: {
    position: 'relative',
    display: 'block',
    padding: '0 0 0 1rem',
    width: '100%',
    float: 'left',
    textAlign: 'left',
    background: config.topbar_bg_color
  },
  container: {
    float: 'left',
    width: '100%'
  },
  subMenu: {
    display: 'grid',
    'grid-template-columns': 'auto auto auto auto',
    float: 'right'
  },
  logoWrapper: {
    float: 'left',
    height: '3rem',
    marginRight: '1rem'
  },
  logo: {
    height: config.kiosk_topbar_logo_height,
    width: 'auto'
  },
  header: {
    float: 'left',
    fontSize: '1rem',
    fontWeight: 700,
    margin: '0.5rem 0',
    padding: 0,
    fontFamily: config.root_font_family,
    lineHeight: 1.5
  },
  nextGuestWrapper: {
    position: 'fixed',
    zIndex: 3,
    top: 0,
    left: 0,
    width: '20vw',
    padding: '0.6rem'
  },
  nextGuest: {
    textAlign: 'center',
    padding: config.kiosk_logout_btn_padding,
    fontSize: '1rem',
    fontWeight: 600,
    background: config.kiosk_logout_btn_bg,
    border: config.kiosk_logout_btn_border,
    borderRadius: '3px',
    color: config.kiosk_logout_btn_font_color,
    fontFamily: config.root_font_family,
    margin: '0.5rem 0.5rem 0.5rem 0.5rem',
  },
  guestInfo: {
    display: 'none',
    float: 'right',
    width: '13rem',
    marginRight: '1rem'
  },
  guestInfoLine: {
    float: 'left',
    width: '100%',
    padding: 0,
    margin: 0
  },
  guestInfoLabel: {
    float: 'left',
    width: '3.5rem',
    fontWeight: 600
  },
  guestInfoValue: {
    float: 'left'
  },
  flagOptions: {
    position: 'relative',
    float: 'right',
    background: config.topbar_bg_color
  },
  room: {
    float: 'right',
    margin: '0.5rem 2rem 0 0.5rem',
    color: '#2b8eb0',
    cursor: 'pointer',
    fontFamily: config.root_font_family,
    fontSize: '1rem'
  },
  welcome: {
    float: 'right',
    margin: '0.5rem 2rem 0 0.5rem',
    padding: 0,
    fontSize: '0.9rem',
    fontFamily: config.root_font_family
  }
});

class TopBar extends React.Component {
  constructor(props) {
    super(props);
    window.topbar = this;

    this.state = {
      showAdminDialog: false,
      showRoomDialog: false,
      showStripeReadersDialog: false
    }
  }

  nextGuest() {
    const {
      settings,
      user,
      selectedMomentIds,
      logout
    } = this.props;

    logout()
      .then(() => {
        this.setState({ loggedOut: true });

        trackEvent('Kiosk.Logout', {
          userId: user.id,
          storyId: user.story_id,
          kiosk: settings.token
        });
      });
  }

  showAdminDialog() {
    this.setState({ showAdminDialog: true });
  }

  hideAdminDialog() {
    this.setState({ showAdminDialog: false });
    window.currentModal && window.currentModal.close();
    document.body.style.overflowY = 'scroll';
  }

  showRoomDialog() {
    this.setState({ showRoomDialog: true });
  }

  hideRoomDialog() {
    this.setState({
      showRoomDialog: false
    });

    window.currentModal && window.currentModal.close();
    document.body.style.overflowY = 'scroll';
  }

  selectLocale(locale) {
    const {
      selectLocale,
      loggedIn
    } = this.props;

    // select client side in redux
    selectLocale(locale);

    if (loggedIn) {
      // save to server
      new UserService().setLocale(locale);
    }
  }

  handleShowStripeReadersDialog(visible) {
    this.setState({
      showStripeReadersDialog: visible
    })
  }

  render() {
    const {
      classes,
      settings,
      user,
      rooms,
      locale,
      localeSettings,
      enabledLocales
    } = this.props;

    // ignoring logo type
    // technically 0 should be URL and 1 should be upload but this isn't being used,
    // if a logo wasn't uploaded, the alt of an empty string just hides the broken image
    let logo = <img className={classes.logo} src={KIOSK_LOGO_URL(settings.token, locale)} alt="" />;

    // todo - switch club med to header setting
    let headerText;
    if (settings.theme === CLUBMED_THEME) {
      headerText = 'CLUB MED PHOTO BOUTIQUE';
    } else {
      headerText = localeSettings.header;
    }

    let header = null;
    if (settings && user) {
      header = (
        <div style={{ float: 'left', width: '20rem' }}>
          <span className={classes.header}>
            {headerText}
          </span>
        </div>
      );
    } else {
      header = (
        <span className={classes.header}>
          {headerText}
        </span>
      );
    }

    let flagOptions = null;
    if (enabledLocales.length > 1) {
      let flags = enabledLocales.map(locale => (
        <Menu.Item as='a' onClick={() => this.selectLocale(locale.locale)}>
          <Flag name={locale.flag} />
        </Menu.Item>
      ));

      let style = {};
      // if (settings.theme === CLUBMED_THEME) {
      //   // for some reason Club Med's flags appear 5px lower
      //   style.marginTop = '-5px';
      // }

      flagOptions = (
        <span className={classes.flagOptions} style={style}>
          <Menu secondary>
            {flags}
          </Menu>
        </span>
      );
    }

    let logoutBtn = null;
    if (user) {
      logoutBtn = (
        <button className={classes.nextGuest} onClick={() => this.nextGuest()}>
          <FormattedMessage {...messages.button_log_out} />
        </button>
      );
    }

    let room = null;
    if (user && settings.login_type === CLUB_MED_LOGIN_TYPE) {
      room = (
        <div className={classes.room} onClick={() => this.showRoomDialog()}>
          <MeetingRoomIcon style={{ margin: '-0.2rem 0.1rem 0' }} />
          <span style={{ fontWeight: 600 }}>{rooms || user.room}</span>
        </div>
      );
    }

    let welcome = null;
    if (user && settings.theme !== HPX_THEME && settings.theme !== ICECASTLE_THEME) {
      if (user.first_name && user.last_name) {
        let name = formatGuestName(user);

        welcome = (
          <p className={classes.welcome}>
            <FormattedMessage {...withValues(messages.kiosk_welcome_message, { name })} />
          </p>
        );
      } else if (user.email) {
        welcome = (
          <p className={classes.welcome}>
            <b style={{ fontWeight: 600 }}>{user.email}</b>
          </p>
        );
      }
    }

    let timeOutDialog = null;
    if (user) {
      timeOutDialog = <TimeOutDialog logout={() => this.nextGuest()} />;
    }

    return (
      <div className={classes.wrapper}>
        <div className={classes.content}>
          <div className={classes.container}>
            <span className={classes.logoWrapper} onClick={() => this.showAdminDialog()}>
              {logo}
            </span>
            {header}
            <div className={classes.subMenu}>
              {room}
              {flagOptions}
              {logoutBtn}
            </div>
            {welcome}
          </div>
        </div>
        <RoomDialog isOpen={this.state.showRoomDialog} close={this.hideRoomDialog.bind(this)} />
        <AdminDialog isOpen={this.state.showAdminDialog} onShowStripeReaders={this.handleShowStripeReadersDialog.bind(this, true)} close={this.hideAdminDialog.bind(this)} />
        <StripeReadersDialog isOpen={this.state.showStripeReadersDialog} onClose={this.handleShowStripeReadersDialog.bind(this, false)} />
        {timeOutDialog}
      </div>
    );
  }
}

const mapStateToProps = state => ({
  settings: state.kioskReducer.settings,
  user: state.kioskReducer.user,
  selectedMomentIds: state.cartReducer.selectedMomentIds,
  view: state.kioskReducer.view,
  email: state.kioskReducer.email,
  guests: state.kioskReducer.guests,
  visits: state.kioskReducer.visits,
  rooms: state.kioskReducer.rooms,
  locale: state.messagesReducer.locale,
  localeSettings: getLocaleSettings(state),
  enabledLocales: getEnabledLocales(state),
  loggedIn: state.kioskReducer.loggedIn
});

export default connect(mapStateToProps, { logout, sendEmail, setEmail, selectLocale })(withStyles(styles)(TopBar));
